// extracted by mini-css-extract-plugin
module.exports = {"multiSelectCrumbs":"_D-z"};